import { TOI_LIVE_DOMAIN, TOI_DEV_DOMAIN } from 'constants/index.js';
import { gaWrapper } from 'helpers/analytics';

export const getFeedDomain = () =>
  __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;

export const getFeedPlatform = (isWapView, frmApp) => {
  let platform = 'web';

  if (isWapView) {
    platform = 'mweb';
    if (frmApp === 'yes') {
      platform = 'app';
    }
  } else if (frmApp === 'yes') {
    platform = 'webapp';
  }

  return platform;
};

export const sendGAEvent = ({ category, action, label, value }) => {
  gaWrapper('send', 'event', category, action, label, value);
};

export const isIpad = onResize => {
  if (window) {
    const mql = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
    if (typeof onResize === 'function') {
      mql.addEventListener('change', e => onResize(e.matches));
    }
    return mql.matches;
  }
  return false;
};

export function triggerWindowScroll() {
  if (window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent('scroll'));
  } else {
    window.scrollTo(window.scrollX, window.scrollY + 1);
    window.scrollTo(window.scrollX, window.scrollY - 1);
  }
}

// geo callback util block
function _isGeoInfoPresent() {
  return (
    typeof window !== 'undefined' &&
    window.geoinfo &&
    typeof window.geoinfo.CountryCode === 'string'
  );
}

function _getParameterByName(name, url) {
  // eslint-disable-next-line no-param-reassign
  if (!url && typeof window !== 'undefined') {
    url = window.location.href;
  }
  if (!url) {
    return undefined;
  }
  // eslint-disable-next-line no-param-reassign
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let geoTimer;

export const getGeoInfo = new Promise((resolve, reject) => {
  const countryPassedFromUrl = _getParameterByName('country_testing');
  if (_isGeoInfoPresent()) {
    resolve({
      country: countryPassedFromUrl || window.geoinfo.CountryCode,
      continent: window.geoinfo.Continent,
    });
  } else {
    geoTimer = setInterval(() => {
      if (_isGeoInfoPresent()) {
        resolve({
          country: countryPassedFromUrl || window.geoinfo.CountryCode,
          continent: window.geoinfo.Continent,
        });
        if (geoTimer) {
          clearInterval(geoTimer);
        }
      }
    }, 1000);
    setTimeout(() => {
      if (geoTimer) {
        clearInterval(geoTimer);
      }
      reject();
    }, 10000);
  }
});
// geo callback util block
